export default __webpack_public_path__ + "static/media/rctsaai_blue.58168a5a.svg";